/**
 * Registers warehouse API executors and wraps mutating calls with the offline queue.
 */
import { registerExecutor, useOfflineQueue } from '@/composables/useOfflineQueue.js'
import {
  commitCart,
  markCheckoutReturned,
  postReturn,
  patchItemMetadataDowntime,
} from '@/api/api.js'

let registered = false

export function ensureOfflineExecutors() {
  if (registered) return
  registered = true
  registerExecutor('cart_checkout', async (payload) => commitCart(payload))
  registerExecutor('mark_returned', async (payload) => {
    if (payload.checkoutId != null) {
      return markCheckoutReturned(payload.checkoutId, payload.condition || 'good')
    }
    return postReturn(payload)
  })
  registerExecutor('downtime', async (payload) =>
    patchItemMetadataDowntime(payload.id, payload.in_downtime, payload.downtime_reason || '')
  )
}

export function useOfflineOps() {
  ensureOfflineExecutors()
  const queue = useOfflineQueue()

  async function queuedCartCheckout(payload) {
    return queue.enqueue('cart_checkout', payload, () => commitCart(payload))
  }

  async function queuedMarkReturned(checkoutId, condition = 'good') {
    const payload = { checkoutId, condition }
    return queue.enqueue('mark_returned', payload, () => markCheckoutReturned(checkoutId, condition))
  }

  async function queuedPostReturn(data) {
    return queue.enqueue('mark_returned', data, () => postReturn(data))
  }

  async function queuedDowntime(id, in_downtime, downtime_reason = '') {
    const payload = { id, in_downtime, downtime_reason }
    return queue.enqueue('downtime', payload, () =>
      patchItemMetadataDowntime(id, in_downtime, downtime_reason)
    )
  }

  return {
    ...queue,
    queuedCartCheckout,
    queuedMarkReturned,
    queuedPostReturn,
    queuedDowntime,
  }
}
